/**
 * Talewave 品牌 - Home 页面 配置
 */
import { homeCommonConfig } from './common'
import type { HomePageConfig } from './types'

export const theme = {
  homeBg: '/images/talewave/home-bg.webp',
  tagsBg: '',
  tagActiveBg: '#53A2FF',
  tagActiveText: '#FFFFFF',
  tagInactiveBg: '#EDF6FF',
  tagInactiveText: '#53A2FF',
  tabActiveGradient: 'linear-gradient(270deg, #F6F7F9 0%, #6B92FD 95%)',
  stickyHeaderBg: 'linear-gradient(180deg, #CFE4FF 0%, #F6F7F9 100%)',
} as const

export const homeConfig: HomePageConfig = {
  theme,
  texts: homeCommonConfig.texts,
}
